// extracted by mini-css-extract-plugin
export default {"content":"addCard_content__exwyM","form_info":"addCard_form_info__0EGDm","title":"addCard_title__ibEYl","btn":"addCard_btn__Dw2fZ"};